import React from 'react'

export default function Footer() {
  const handleNewsletter = (e) => {
    e.preventDefault()
    e.target.reset()
  }

  return (
    <>
      {/* Main Footer */}
      <footer className="sisdi-footer">
        <div className="footer-main">
          <div className="footer-grid">

            {/* Brand */}
            <div className="footer-brand">
              <img src="/images/logo.png" alt="SISDI Logo" />
              <p>
                Schools In Soccer Development Initiative is a pan-African nonprofit
                empowering children through football and education. We nurture skilled
                athletes and well-rounded individuals who contribute meaningfully to
                their communities.
              </p>
              <span className="footer-tagline">Building futures — one child at a time.</span>
              <div className="footer-socials" style={{ marginTop: '1.5rem' }}>
                <a href="https://web.facebook.com/profile.php?id=61563594750242" aria-label="Facebook" target="_blank" rel="noreferrer">
                  <i className="bi bi-facebook"></i>
                </a>
                <a href="https://x.com/schoolsinsoccer?s=20" aria-label="Twitter/X" target="_blank" rel="noreferrer">
                  <i className="bi bi-twitter-x"></i>
                </a>
                <a href="https://www.instagram.com/schoolsinsoccer_" aria-label="Instagram" target="_blank" rel="noreferrer">
                  <i className="bi bi-instagram"></i>
                </a>
                <a href="https://www.linkedin.com/company/schools-in-soccer-development-initiative" aria-label="LinkedIn" target="_blank" rel="noreferrer">
                  <i className="bi bi-linkedin"></i>
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div className="footer-col">
              <h5>Quick Links</h5>
              <ul className="footer-links">
                <li><a href="/">Home</a></li>
                <li><a href="/about">About Us</a></li>
                <li><a href="/impact">Impact</a></li>
                <li><a href="/get-involved">Get Involved</a></li>
                <li><a href="/donate">Donate</a></li>
                <li><a href="/contact">Contact</a></li>
              </ul>
            </div>

            {/* Programs */}
            <div className="footer-col">
              <h5>Programs</h5>
              <ul className="footer-links">
                <li><a href="/programs">Football Training</a></li>
                <li><a href="/programs">Read, Learn, Play</a></li>
                <li><a href="/programs">School Competitions</a></li>
              </ul>
            </div>

            {/* Contact */}
            <div className="footer-col">
              <h5>Contact Us</h5>
              <div className="footer-contact-item">
                <i className="bi bi-envelope-fill"></i>
                <a href="mailto:schoolsinsoccer@gmail.com">schoolsinsoccer@gmail.com</a>
              </div>
              <div className="footer-contact-item">
                <i className="bi bi-telephone-fill"></i>
                <a href="tel:+2349122328676">+234 912 232 8676</a>
              </div>
              <div className="footer-contact-item">
                <i className="bi bi-whatsapp"></i>
                <a href="https://wa.me/2348054619954" target="_blank" rel="noreferrer">Chat on WhatsApp</a>
              </div>
            </div>

          </div>
        </div>

        {/* Bottom bar */}
        <div className="footer-bottom">
          <span>&copy; {new Date().getFullYear()} SISDI &mdash; Schools In Soccer Development Initiative. All rights reserved.</span>
          <span className="footer-badge">
            <i className="bi bi-patch-check-fill" style={{ color: 'var(--color-accent)' }}></i>
            Registered Nonprofit &middot; Pan-African
          </span>
        </div>
      </footer>
    </>
  )
}
